var path = 'app/scripts/modules/oracle/common/ocid/ocid.template.html';
var html = "<span>\n  <span ng-hide=\"showOcid\">\n    {{ocid | truncateOcid}}\n    <a href=\"\" ng-click=\"showOcid = true\">Show</a>\n  </span>\n  <span ng-show=\"showOcid\">\n    {{ocid}}\n    <a href=\"\" ng-click=\"showOcid = false\">Hide</a>\n  </span>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/oracle/common/ocid/ocid.template.html
// module id = 4058
// module chunks = 0